import React, { createContext, useContext, useState } from "react";
import { translations } from "@/lib/translations";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hospital_lang") || "en");
  const change = (l) => {
    setLang(l);
    localStorage.setItem("hospital_lang", l);
  };
  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  return <LangCtx.Provider value={{ lang, setLang: change, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
